// @oasis-permission-inherits: /capcode (capcode:view)
import { createFileRoute } from "@tanstack/react-router";

import { ChatSurface } from "~/modules/cap-code/components/chat-surface";

export const Route = createFileRoute("/_dash/capcode/conversations/new")({
  component: ChatSurface,
});
